// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__B6aCW","hasLoading":"Table_hasLoading__qnaYI","loading":"Table_loading__5WsOV","sortIcon":"Table_sortIcon__YQ4lQ"};